import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/signup', /^\/validateSignup/] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // console.log('from', from)
  // console.log('to', to)

  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  //console.log('From', from)
  //console.log('To', to)
  //console.log(store.getters.userPermission)

  const hasConnectred = store.getters.isLoggedIn

  if (hasConnectred) {

    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      try {
        next({ path: '/' })
      }
      catch (err) {
        // Do nothing
      }
      NProgress.done()
    } else {

      const hasRoles = store.getters.userPermission  && store.getters.userPermission !== ''

      if (hasRoles) {
        try {
          next()
        }
        catch (err) {
          // Do nothing
        }
      } else {

        try {
          // get user permission
          const isAdmin = store.getters.isAdmin
          const userPermission = store.getters.userPermission

          // generate accessible routes map based on roles
          const accessRoutes = store.dispatch('permission/GenerateRoutes', { roles: userPermission, isAdmin: isAdmin })

          // dynamically add accessible routes
          router.matcher.addRoutes(accessRoutes)

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })

        } catch (error) {
          // remove store and go to login page to re-login
          await store.dispatch('tangoEnv/logout') // S06
          await store.dispatch('user/logout') // S06
          Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    let whiteListed = false
    whiteList.forEach(e => {
      if (e instanceof RegExp) {
        if (e.test(to.path)) whiteListed = true
      }
      else {
        if (to.path === e) whiteListed = true
      }
    })
    /* has no logged in */
    // if (whiteList.indexOf(to.path) !== -1) {
    if (whiteListed) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`) // S06
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
